import { FC, useEffect, useState } from 'react';
import styles from './connect-with-us.module.scss';
import { useIntl } from 'react-intl';
import { useDetermineLocale } from '@/hooks';
import { isPharmaprixBanner } from '@/utils';
import LinkButton from '@/components/link-button';

const ConnectWithUs: FC = () => {
  const { formatMessage } = useIntl();

  const newsLetterHeading = formatMessage({ id: 'newsLetter' });
  const locale = useDetermineLocale();
  const isPharmaprix = isPharmaprixBanner();
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    setUrl(`https://www.${isPharmaprix ? 'pharmaprix' : 'shoppersdrugmart'}.ca/${locale}`);
  }, [isPharmaprix, locale]);

  return (
    <div className={styles.connectWithUsContainer}>
      <div className={styles.newsLetterSignUp}>
        <p className={styles.newsLetterHeading}>{newsLetterHeading}</p>
        {url ? (
          <div className={styles.signUpButtons}>
            <LinkButton variant="secondary" href={`${url}/email-signup`}>
              {formatMessage({ id: 'emailSignUp' })}
            </LinkButton>
            <LinkButton variant="secondary" href={`${url}/promotions/mobile-text-offers`}>
              {formatMessage({ id: 'textSignUp' })}
            </LinkButton>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ConnectWithUs;
